import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount?: number;
  className?: string;
}
export function PriceDisplay({
  amount = 9000,
  className = ''
}: PriceDisplayProps) {
  const [formattedPrice, setFormattedPrice] = useState(`${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`);
  useEffect(() => {
    const locale = navigator.language || 'es-AR';
    let symbol = '$';
    const lowerLocale = locale.toLowerCase();
    if (lowerLocale.includes('es-es') || lowerLocale === 'es') {
      symbol = '€';
    } else if (lowerLocale.includes('en-gb')) {
      symbol = '£';
    } else if (lowerLocale.includes('en-us') || lowerLocale === 'en') {
      symbol = '$';
    }
    // Format with dots for thousands (Argentine style)
    const formattedNumber = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    setFormattedPrice(`${symbol}${formattedNumber}`);
  }, [amount]);
  return <span className={className} data-id="element-222">{formattedPrice}</span>;
}